<template>
  <artmisads-modal
    v-model:open="visible"
    title="Add Brand to Blacklist"
    :width="500"
    :destroyOnClose="false"
    :maskClosable="false"
    :footer="null"
    :onCancel="onCancelClose"
  >
    <div class="content">
      <div class="content-item" ref="marketplaceRef">
        <div class="content-item-title">
          Brand Name
        </div>
        <div class="content-item-input" ref="marketplaceRef">
           <artmisads-select show-search v-model:value="filter.brandId" style="width: 232px" :options="brandOptions"
          @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="All"
          allowClear @change="handleBrandChange"  :getPopupContainer="() => $refs.marketplaceRef"/>

        </div>
      </div>
      <div class="btn-box">
        <artmisads-button type="primary" @click="handleConfirm"
          >Confirm</artmisads-button
        >
      </div>
    </div>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineEmits, defineExpose } from 'vue'

import { publisherAdminApi } from '~/server/index'
import { message,Modal} from "ant-design-vue";
const visible = ref(false)
const brandOptions = ref([])
const filter = ref({
  brandId:'',
  brandName:'',
})
const emits = defineEmits(['refreshList'])
const open = () => {
  visible.value = true
  filter.value.brandId = ''
  filter.value.brandName = ''
}
const onCancelClose = () => {
  visible.value = false
  filter.value.brandId = ''
  filter.value.brandName = ''
}
const searchBrand = async keyword => {
  let res, params
   params = {
      keyword,
      marketplace: 'amazon.com'
    };
   res= await publisherAdminApi.searchBrand(params);
      res = res.map(item => {
      // 检查是否存在重复的 amazonBrandName
      const hasDuplicate = res.some(otherItem => 
        otherItem.amazonBrandName === item.amazonBrandName && 
        otherItem.id !== item.id
      );

      return {
        ...item,
        label: hasDuplicate ? `${item.amazonBrandName} (${item.amazonProfileAccountInfoName})` : item.amazonBrandName,
        value: item.id
      };
    })
    brandOptions.value = res
}
const handleConfirm = async () => {
  if (!filter.value.brandId) {
    message.error('Please select a brand')
    return
  }
  const res = await publisherAdminApi.addBlacklist({
    brandName: filter.value.brandName,
  })
  if (res.success) {
    message.success('Add success')
    emits('refreshList')
    visible.value = false
  }
}
const handleBrandChange = (value) => {

 const brandObj = brandOptions.value.find(item => item.value === value)
 if (value) {
  filter.value.brandName = brandObj.amazonBrandName
 }
}
// 暴露方法给父组件
defineExpose({
  open,
})
</script>
<style scoped lang="less">
  .btn-box{
   margin-top: 20px;
   display: flex;
   align-items: center;
   justify-content: flex-end;
  }
</style>
